module.exports = __webpack_public_path__ + "static/media/digitalent.665be8ac.png";